import React from 'react';
import {
	Container,
	DropDownWrapper,
	StyledHelper,
} from './BreakDownFilters.style';
import { ApButtonMain, ApSimpleDropdown } from '@alixpartners/ui-components';
import {
	BREAKDOWN_BY_FILTERS,
	MICRO_MACRO_FILTERS,
} from 'SpendController/utils';
import {
	MultiSelectWrapper,
	SingleFilterWrapper,
	StackFilterWrapper,
} from '../Components.styles';
import MultiSelect from '../MultiSelect/MultiSelect';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
function BreakDownFilters(props) {
	const {
		filters,
		selectedBreakDownFilter,
		handleBreakDownFilterChange,
		handleResetFilters,
	} = useSpendControllerFiltersContext();
	const { selectedSpendType, handleSpendTypeChange, gridApi } = props;
	const { stack_1, stack_2 } = filters;
	return (
		<Container>
			<StyledHelper>Filter by:</StyledHelper>
			<DropDownWrapper>
				<ApSimpleDropdown
					options={BREAKDOWN_BY_FILTERS}
					selected={BREAKDOWN_BY_FILTERS.find(
						el => el.value === selectedBreakDownFilter
					)}
					onChange={v => handleBreakDownFilterChange(v.value)}
				/>
			</DropDownWrapper>
			<StackFilterWrapper>
				{stack_2.map(
					(element, key) =>
						element.key === selectedBreakDownFilter && (
							<SingleFilterWrapper key={key}>
								<MultiSelect
									{...element}
									onChange={value =>
										element.onChange('stack_2[' + key + '].selected', value)
									}
								/>
							</SingleFilterWrapper>
						)
				)}
				{stack_1.map(
					(element, key) =>
						element.key === selectedBreakDownFilter && (
							<SingleFilterWrapper key={key}>
								<MultiSelect
									{...element}
									onChange={value =>
										element.onChange('stack_1[' + key + '].selected', value)
									}
								/>
							</SingleFilterWrapper>
						)
				)}
			</StackFilterWrapper>

			{props.location?.pathname === '/spend-controller/baseline' && (
				<MultiSelectWrapper>
					<MultiSelect
						label={`Tail Spend Type`}
						options={MICRO_MACRO_FILTERS}
						selected={MICRO_MACRO_FILTERS.filter(filter =>
							selectedSpendType.includes(filter.value)
						).map(filter => filter.value)}
						onChange={v => handleSpendTypeChange(v)}
					/>
				</MultiSelectWrapper>
			)}
			<ApButtonMain
				onClick={() => {
					if (gridApi) {
						gridApi.setFilterModel(null);
					}
					handleResetFilters();
				}}
				style={{
					margin: '5px 7px 4px 0 ',
					borderRadius: '0',
				}}
				small
			>
				Reset Filters
			</ApButtonMain>
		</Container>
	);
}

export default BreakDownFilters;
